(function() {
  'use strict';

  const BLOCKED_DOMAINS = window.block_fonts_domains;
  let isBlocking = true;
  let hasUnblocked = false;
  const blockedResources = [];

  // Helper function to check if URL contains any blocked domain
  function isBlockedDomain(url) {
    return BLOCKED_DOMAINS.some(domain => url.includes(domain));
  }

  function unblockAndLoad() {
    if (hasUnblocked) return;

    hasUnblocked = true;
    isBlocking = false;

    blockedResources.forEach(resource => {
      if (resource.type === 'link') {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = resource.url;
        document.head.appendChild(link);
      } else if (resource.type === 'script') {
        const script = document.createElement('script');
        script.src = resource.url;
        document.head.appendChild(script);
      }
    });

    blockedResources.length = 0;
  }

  function setupUnblockTriggers() {
    let triggered = false;

    function trigger() {
      if (triggered) return;
      triggered = true;

      setTimeout(unblockAndLoad, 100);

      window.removeEventListener('scroll', trigger);
      window.removeEventListener('click', trigger);
      window.removeEventListener('touchstart', trigger);
      window.removeEventListener('keydown', trigger);
    }

    window.addEventListener('scroll', trigger, { passive: true });
    window.addEventListener('click', trigger);
    window.addEventListener('touchstart', trigger, { passive: true });
    window.addEventListener('keydown', trigger);
  }

  // Block fetch requests
  if (window.fetch) {
    const originalFetch = window.fetch;

    window.fetch = function(url, options) {
      if (isBlocking && typeof url === 'string' && isBlockedDomain(url)) {
        blockedResources.push({ type: 'fetch', url: url });
        return Promise.reject(new Error('Blocked domain - will load on interaction'));
      }

      return originalFetch.apply(this, arguments);
    };
  }

  // Block XMLHttpRequest
  if (window.XMLHttpRequest) {
    const originalXHR = window.XMLHttpRequest;

    window.XMLHttpRequest = function() {
      const xhr = new originalXHR();
      const originalOpen = xhr.open;

      xhr.open = function(method, url, ...args) {
        if (isBlocking && typeof url === 'string' && isBlockedDomain(url)) {
          blockedResources.push({ type: 'xhr', url: url });
          throw new Error('Blocked domain - will load on interaction');
        }

        return originalOpen.apply(this, [method, url, ...args]);
      };

      return xhr;
    };
  }


  if (document.createElement) {
    const originalCreateElement = document.createElement;

    document.createElement = function(tagName) {
      const element = originalCreateElement.apply(this, arguments);

      if (tagName.toLowerCase() === 'link') {
        const originalSetAttribute = element.setAttribute;

        element.setAttribute = function(name, value) {
          if (isBlocking && name === 'href' && typeof value === 'string' && isBlockedDomain(value)) {
            blockedResources.push({ type: 'link', url: value });
            return; // Don't set the href
          }

          return originalSetAttribute.apply(this, arguments);
        };
      }

      if (tagName.toLowerCase() === 'script') {
        const originalSetAttribute = element.setAttribute;

        element.setAttribute = function(name, value) {
          if (isBlocking && name === 'src' && typeof value === 'string' && isBlockedDomain(value)) {
            blockedResources.push({ type: 'script', url: value });
            return; // Don't set the src
          }

          return originalSetAttribute.apply(this, arguments);
        };
      }

      return element;
    };
  }

  // MutationObserver to watch for dynamically added elements
  function setupMutationObserver() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && isBlocking) {
              if (node.tagName === 'LINK') {
                const href = node.href || node.getAttribute('href');

                if (href && isBlockedDomain(href)) {
                  blockedResources.push({ type: 'link', url: href });
                  node.remove();
                }
              }

              if (node.tagName === 'STYLE') {
                const textContent = node.textContent || node.innerHTML;

                if (textContent && isBlockedDomain(textContent)) {
                  node.remove();
                }
              }

              if (node.tagName === 'SCRIPT') {
                const src = node.src || node.getAttribute('src');

                if (src && isBlockedDomain(src)) {
                  blockedResources.push({ type: 'script', url: src });
                  node.remove();
                }
              }
            }
          });
        }
      });
    });

    // Observe the document head and body
    observer.observe(document.head, {
      childList: true,
      subtree: true
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupMutationObserver();
      setupUnblockTriggers();
    });
  } else {
    setupMutationObserver();
    setupUnblockTriggers();
  }

  // Block existing elements on page load
  function blockExistingElements() {
    if (!isBlocking) return;

    // Block existing link elements
    const linkSelectors = BLOCKED_DOMAINS.map(domain => `link[href*="${domain}"]`).join(', ');
    const links = document.querySelectorAll(linkSelectors);

    links.forEach(function(link) {
      const href = link.href;
      blockedResources.push({ type: 'link', url: href });
      link.remove();
    });

    // Block existing style elements
    const styles = document.querySelectorAll('style');

    styles.forEach(function(style) {
      const textContent = style.textContent || style.innerHTML;

      if (textContent && isBlockedDomain(textContent)) {
        style.remove();
      }
    });
  }

  // Run immediately and after DOM is ready
  blockExistingElements();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blockExistingElements);
  }
})();